import Hero from "@/components/site/Hero";
import Countdown from "@/components/site/Countdown";
import OurMission from "@/components/site/OurMission";
import EmotionalMedia from "@/components/site/EmotionalMedia";
import WhyTravel from "@/components/site/WhyTravel";
import TrustBanner from "@/components/site/TrustBanner";
import FeaturedTestimonials from "@/components/site/FeaturedTestimonials";
import CommunityImpact from "@/components/site/CommunityImpact";
import GallerySection from "@/components/site/GallerySection";
import WhatToBring from "@/components/site/WhatToBring";
import CommunitySection from "@/components/site/CommunitySection";
import FAQSection from "@/components/site/FAQSection";
import RegistrationForm from "@/components/site/RegistrationForm";
import { Link } from "react-router-dom";
import usePageTitle from "@/hooks/usePageTitle";

export default function Home() {
  usePageTitle("Maqam Community Initiatives — Community-Led Umrah");
  return (
    <div data-testid="page-home">
      <Hero />
      <Countdown />
      <OurMission />
      <EmotionalMedia />
      <WhyTravel />
      <TrustBanner />
      <FeaturedTestimonials compact />
      <CommunityImpact />
      <div className="text-center bg-white pb-16 md:pb-20 -mt-4">
        <Link
          to="/testimonials"
          data-testid="home-see-all-reviews"
          className="inline-flex items-center gap-2 text-sm font-semibold text-[color:var(--maqam-navy)] underline underline-offset-4 decoration-[color:var(--maqam-gold)] hover:decoration-2"
        >
          See all pilgrim reviews →
        </Link>
      </div>
      <GallerySection />
      <WhatToBring preview />
      <CommunitySection />
      <FAQSection limit={5} />
      <RegistrationForm />
    </div>
  );
}
